import React, { useState } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";
import { deleteAccount } from "./functions/functions";

const AccountDeletionForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [reason, setReason] = useState("");
  const [buttonTitle, setButtonTitle] = useState("Submit");

  const handleSubmit = () => {
    // Logic for form submission
    // console.log("Form Submitted", email, password, reason);

    if (email.length === 0 || password.length === 0) {
      alert("Please enter your email and password first!");
      return;
    }

    try {
      setButtonTitle("Loading...");
      deleteAccount(email, password, reason)
        .then((res) => {
          setButtonTitle("Submit");
          alert("Account deleted successfully!");
          setEmail("");
          setPassword("");
          setReason("");
        })
        .catch((err) => {
          setButtonTitle("Submit");
          alert(err?.response?.data?.message);
          console.log(err);
        });
    } catch (error) {
      setButtonTitle("Submit");
      // alert(error?.message);
      // console.log(error);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 500,
        margin: "auto",
        mt: 10,
        p: 4,
        border: "1px solid #ccc",
        borderRadius: 2,
        boxShadow: 3,
        textAlign: "center",
      }}
    >
      <Typography
        sx={{ textAlign: "center", fontWeight: "bold", mb: 4 }}
        variant="h4"
      >
        Account Deletion Form
      </Typography>

      <TextField
        label="Email"
        type="email"
        variant="outlined"
        fullWidth
        margin="normal"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <TextField
        label="Password"
        type="password"
        variant="outlined"
        fullWidth
        margin="normal"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <TextField
        label="Reason for Deletion"
        variant="outlined"
        multiline
        rows={4}
        fullWidth
        margin="normal"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
      />

      <Button
        variant="contained"
        color="primary"
        fullWidth
        disabled={buttonTitle === "Loading..."}
        sx={{ mt: 3 }}
        onClick={handleSubmit}
      >
        {buttonTitle}
      </Button>
    </Box>
  );
};

export default AccountDeletionForm;
